<template>
    <div>
        <v-card-title>
            {{ $t('corporate.captable.current.title') }}
            <v-spacer></v-spacer>
            <template v-if="isEmployee">
                <modal-captable :loading="loading" :client="client" :company-info="client.companyInfo" :current-captable="item" :is-new="true" @close-captable-success-dialog="refreshAll"></modal-captable>
            </template>
        </v-card-title>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-card v-if="item" class="mt-4" elevation="0" outlined>
            <data-table-captable-read :client="client" :company-info="client.companyInfo" :item="item" @refresh-all="refreshAll"></data-table-captable-read>
        </v-card>
        <div v-else class="text-center mt-4 mb-4"><span style="color: red">{{ $t('corporate.captable.current.empty') }}</span></div>
    </div>
</template>

<script>
import API from '@/api'
import ModalCaptable from '@/components/corporate/ModalCaptable'
import DataTableCaptableRead from '@/components/corporate/DataTableCaptableRead'

export default {
    name: 'current-captable',
    props: ['client'],
    components: {
        ModalCaptable,
        DataTableCaptableRead
    },
    data: function () {
        return {
            loading: false,
            item: undefined
        }
    },
    mounted () {
        this.loadData()
    },
    computed: {
        isEmployee: function () {
            return this.$helpers.checkIsEmployee()
        }
    },
    methods: {
        loadData () {
            this.loading = true
            let endpoint = API.EndPoints.getCorporateCaptable
            let where = {
                client: { __type: 'Pointer', className: 'Client', objectId: this.$helpers.getCorporateClientId(this.$route.name, 'ClienteSocietarioCaptable', this.$route.params.id) },
                isCurrent: true
            }
            const params = {
                limit: 1,
                skip: 0,
                count: true,
                order: '-createdAt',
                where: JSON.stringify(where)
            }
            new API(endpoint, params).request().then(response => {
                if (response.data.results[0] !== undefined) {
                    this.item = Object.assign({}, response.data.results[0])
                }
                this.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        refreshAll () {
            this.$emit('refresh-all')
            this.loadData()
        }
    }
}
</script>
